import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Container,
  Paper,
  Typography,
  TextField,
  Button,
} from "@mui/material";
import { useFakeToken } from "../../hooks/useFakeToken";

export const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const { loggedIn, mockLogin } = useFakeToken();
  const navigate = useNavigate();

  useEffect(() => {
    if (loggedIn) {
      navigate("/");
    }
  }, [loggedIn, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (mockLogin(email, password)) {
      navigate("/");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        pt: { xs: 10, md: 12 },
        pb: 4,
        background:
          "linear-gradient(180deg, #1a472a 0%, #2d5a3d 50%, #165B33 100%)",
      }}
    >
      <Container maxWidth="sm">
        <Paper
          elevation={8}
          sx={{
            p: { xs: 3, md: 4 },
            borderRadius: 4,
            background: "rgba(255, 255, 255, 0.95)",
            backdropFilter: "blur(10px)",
            border: "3px solid #c41e3a",
          }}
        >
          {/* Header */}
          <Box sx={{ textAlign: "center", mb: 3 }}>
            <Typography
              variant="h3"
              sx={{
                fontFamily: '"Mountains of Christmas", cursive',
                color: "#c41e3a",
                fontWeight: 700,
                mb: 1,
              }}
            >
              🎄 Καλωσόρισες! 🎄
            </Typography>
            <Typography variant="body1" color="text.secondary">
              Συνδέσου για τη Χριστουγεννιάτικη Λοταρία
            </Typography>
          </Box>

          {/* Form */}
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 2 }}
              required
            />
            <TextField
              fullWidth
              label="Κωδικός"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 3 }}
              required
            />
            <Button
              type="submit"
              variant="contained"
              fullWidth
              size="large"
              sx={{
                py: 1.5,
                backgroundColor: "#c41e3a",
                fontWeight: 600,
                fontSize: "1.1rem",
                "&:hover": {
                  backgroundColor: "#a01830",
                },
              }}
            >
              {"Συνδεση"}
            </Button>
          </form>

          <Box sx={{ textAlign: "center", mt: 3 }}>
            <Typography variant="body2" color="text.secondary">
              🎅 Χο Χο Χο! Καλή τύχη στη λοταρία! 🎁
            </Typography>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
};
